import React from 'react'
import ApproverExpenseReports from 'src/app/ApproverExpenseReports/ApproverExpenseReports'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expensesOutOfPocketReportsRouteProps } from 'src/navigation/routeProps'

const ExpensesOutOfPocketReportsAppRoute: AppRoute = {
  routeProps: expensesOutOfPocketReportsRouteProps,
  component: <ApproverExpenseReports />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ExpensesOutOfPocketReportsAppRoute
